/* eslint-disable import/no-anonymous-default-export */
import requestOptions from './requestOptions'
import reportsMapper from '../models/Reports_Mapper'

const clientData = async (paremeters, businessModueId, year) => {
    const options = requestOptions.options('GET', paremeters, '')
    const resp = await fetch(global.CLIENT_REPORT + '/' + businessModueId + '/' + year, options)
    const data = await resp.json();
    const response = reportsMapper.clienDataMapper(data.data);
    return response;
}

const clientDataByMonth = async (page, perPage, search, paremeters, businessModueId, month, year) => {
    const options = requestOptions.options('GET', paremeters, '')
    const resp = await fetch(global.CLIENT_REPORTBYMONTH + '/' + businessModueId + '/' + month + '/' + year + '/' + page + '/' + perPage + '/' + search, options)
    const data = await resp.json();
    const response = reportsMapper.clienDataByMonthMapper(data.data);
    return response;
}

const earnData = async (paremeters, businessModueId, year) => {
    const options = requestOptions.options('GET', paremeters, '')
    const resp = await fetch(global.CLIENT_EARN_REPORT + '/' + businessModueId + '/' + year, options)
    const data = await resp.json();
    const response = reportsMapper.earnDataMapper(data.data);
    return response;
}

const earnDataByMonth = async (paremeters, businessModueId, month, year, page, perPage, search) => {
    const options = requestOptions.options('GET', paremeters, '')
    const resp = await fetch(global.CLIENT_ERANBYMONTH + '/' + businessModueId + '/' + month + '/' + year + '/' + page + '/' + perPage + '/' + search, options)
    const data = await resp.json();
    const response = reportsMapper.earnDataByMonthMapper(data.data);
    return response;
}

const statusData = async (paremeters, businessModueId, year) => {
    const options = requestOptions.options('GET', paremeters, '')
    const resp = await fetch(global.CLIENT_STATUS + '/' + businessModueId + '/' + year, options)
    const data = await resp.json();
    const barData = reportsMapper.earnBarDataMapper(data.data["barData"]);
    const donaData = reportsMapper.earnDonutDataMapper(data.data["donaData"]);
    let response = [];
    response[0] = barData;
    response[1] = donaData;
    return response;
}

const statusDataDonut = async (paremeters, businessModueId, service, year) => {
    const options = requestOptions.options('GET', paremeters, '')
    const resp = await fetch(global.CLIENT_STATUS_SERVICE + '/' + businessModueId + '/' + service + '/' + year, options)
    const data = await resp.json();
    const response = reportsMapper.statusDataByServiceMapper(data.data);
    return response;
}

export default {
    clientData,
    clientDataByMonth,
    earnData,
    earnDataByMonth,
    statusData,
    statusDataDonut
}